export default class PasswordGenarator {

    constructor() {
        this.charsets = {
            lowercase: 'abcdefghijklmnopqrstuvwxyz',
            uppercase: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
            special: '()!@&%_-',
            number: '0123456789'
        };
    }

    generate(type, length) {
        const charset = this.charsets[type];
        let result = "";
        for (let i = 0, n = charset.length; i < length; ++i) {
            result += charset.charAt(Math.floor(Math.random() * n));
        }
        return result;
    }
}